
import { useState } from "react";
import { CustomerSignup } from "../../api/Auth";
import { toast } from "react-toastify";

interface SignupModalProps {
    onClose: () => void;
    onOpenLogin: () => void;
}
export default function SignupModal({ onClose, onOpenLogin }: SignupModalProps) {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [affiliateSale, setAffiliateSale] = useState("");
    const [agreed, setAgreed] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!firstName || !lastName || !phone || !email || !password) {
            toast.error("Vui lòng điền đầy đủ thông tin.");
            return;
        }
        if (!agreed) {
            toast.error("Vui lòng đồng ý với Điều khoản sử dụng.");
            return;
        }

        setLoading(true);
        try {
            const resp = await CustomerSignup(firstName, lastName, phone, email, password, affiliateSale);
            if (resp.status) {
                toast.success("Đăng ký thành công!");
                setTimeout(() => {
                    onClose();
                    onOpenLogin();
                }, 1500);
            } else {
                toast.error(resp.msg || "Đăng ký thất bại");
            }
        } catch (error) {
            toast.error("Có lỗi xảy ra, vui lòng thử lại.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            role="presentation"
            className="styles_signupModal__9PV_V styles_modalItem__YKbSY"
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            style={{ position: "fixed", zIndex: 1300, inset: 0 }}
        >
            <div
                onClick={onClose}
                aria-hidden="true"
                style={{
                    zIndex: -1,
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    WebkitTapHighlightColor: "transparent",
                }}
            />

            <div tabIndex={0} data-test="sentinelStart" />

            <div className="styles_auth_modal_content__gD2DP" tabIndex={-1}>

                <div className="MuiGrid-root styles_auth_modal_header__8MVV9 MuiGrid-container MuiGrid-align-items-xs-center MuiGrid-justify-content-xs-space-between">
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-10">
                        <header className="styles_auth_modal_title__7Ht8G">
                            <div className="styles_paddingLeft__o43dz">
                                <span>Đăng ký tài khoản</span>
                            </div>
                        </header>
                    </div>

                    {/* CLOSE BUTTON */}
                    <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-1">
                        <button
                            className="MuiButtonBase-root MuiIconButton-root styles_auth_modal_close__CfXli"
                            type="button"
                            aria-label="close"
                            onClick={onClose}
                        >
                            <span className="MuiIconButton-label">
                                <svg
                                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeSmall"
                                    viewBox="0 0 24 24"
                                    aria-hidden="true"
                                >
                                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                </svg>
                            </span>
                            <span className="MuiTouchRipple-root" />
                        </button>
                    </div>
                </div>

                <div className="styles_auth_modal_body__le_XM">
                    <div className="styles_modalContainer__uy711">
                        <form className="styles_accountCreationForm__N_GxJ" onSubmit={handleSubmit}>

                            <div className="styles_stepContainer__ey1bO">

                                {/* First Name & Last Name */}
                                <div className="input-block-2colums">
                                    <div className="MuiFormControl-root-315 styles_accountCreationForm__input__1_asx MuiFormControl-fullWidth-318">
                                        <div className="MuiInputBase-root-331 MuiOutlinedInput-root-319 sc-242007b2-0 cWOwtw MuiInputBase-formControl-332">
                                            <input
                                                name="firstName"
                                                placeholder="Họ *"
                                                className="MuiInputBase-input-339 MuiOutlinedInput-input-326"
                                                style={{ width: '100%' }}
                                                value={firstName}
                                                onChange={(e) => setFirstName(e.target.value)}
                                            />
                                            <fieldset className="jss353 MuiOutlinedInput-notchedOutline-325">
                                                <legend className="jss354"><span>&ZeroWidthSpace;</span></legend>
                                            </fieldset>
                                        </div>
                                    </div>
                                    <div className="MuiFormControl-root-315 styles_accountCreationForm__input__1_asx MuiFormControl-fullWidth-318">
                                        <div className="MuiInputBase-root-331 MuiOutlinedInput-root-319 sc-242007b2-0 cWOwtw MuiInputBase-formControl-332">
                                            <input
                                                name="lastName"
                                                placeholder="Tên *"
                                                className="MuiInputBase-input-339 MuiOutlinedInput-input-326"
                                                value={lastName}
                                                style={{ width: '100%' }}
                                                onChange={(e) => setLastName(e.target.value)}
                                            />
                                            <fieldset className="jss353 MuiOutlinedInput-notchedOutline-325">
                                                <legend className="jss354"><span>&ZeroWidthSpace;</span></legend>
                                            </fieldset>
                                        </div>
                                    </div>
                                </div>

                                {/* PHONE */}
                                <div className="MuiFormControl-root-315 styles_accountCreationForm__input__1_asx styles_iconStart__c2LGF MuiFormControl-fullWidth-318">
                                    <div className="MuiInputBase-root-331 MuiOutlinedInput-root-319 sc-242007b2-0 cWOwtw MuiInputBase-formControl-332 MuiInputBase-adornedStart-333 MuiOutlinedInput-adornedStart-321">
                                        <div className="MuiInputAdornment-root-346 MuiInputAdornment-positionStart-348">
                                            <span>
                                                <img
                                                    src="https://cdn-web-next.thuocsi.vn/icons/register/phone.svg"
                                                    alt=""
                                                />
                                            </span>
                                        </div>

                                        <input
                                            name="phoneNumber"
                                            placeholder="Nhập số điện thoại *"
                                            type="tel"
                                            className="MuiInputBase-input-339 MuiOutlinedInput-input-326 MuiInputBase-inputAdornedStart-343 MuiOutlinedInput-inputAdornedStart-329"
                                            value={phone}
                                            onChange={(e) => setPhone(e.target.value)}
                                        />

                                        <fieldset className="jss353 MuiOutlinedInput-notchedOutline-325">
                                            <legend className="jss354">
                                                <span>&ZeroWidthSpace;</span>
                                            </legend>
                                        </fieldset>
                                    </div>
                                </div>

                                {/* EMAIL */}
                                <div className="MuiFormControl-root-315 styles_accountCreationForm__input__1_asx styles_iconStart__c2LGF MuiFormControl-fullWidth-318">
                                    <div className="MuiInputBase-root-331 MuiOutlinedInput-root-319 sc-242007b2-0 cWOwtw MuiInputBase-formControl-332 MuiInputBase-adornedStart-333 MuiOutlinedInput-adornedStart-321">
                                        <div className="MuiInputAdornment-root-346 MuiInputAdornment-positionStart-348">
                                            <span>
                                                <img
                                                    src="https://cdn-web-next.thuocsi.vn/assets/404/mail.svg"
                                                    alt=""
                                                />
                                            </span>
                                        </div>

                                        <input
                                            name="email"
                                            placeholder="Nhập email *"
                                            type="email"
                                            className="MuiInputBase-input-339 MuiOutlinedInput-input-326 MuiInputBase-inputAdornedStart-343 MuiOutlinedInput-inputAdornedStart-329"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                        />

                                        <fieldset className="jss353 MuiOutlinedInput-notchedOutline-325">
                                            <legend className="jss354">
                                                <span>&ZeroWidthSpace;</span>
                                            </legend>
                                        </fieldset>
                                    </div>
                                </div>

                                {/* PASSWORD */}
                                <div className="MuiFormControl-root-315 styles_accountCreationForm__input__1_asx styles_iconStart__c2LGF MuiFormControl-fullWidth-318">
                                    <div className="MuiInputBase-root-331 MuiOutlinedInput-root-319 sc-242007b2-0 cWOwtw MuiInputBase-formControl-332 MuiInputBase-adornedStart-333 MuiOutlinedInput-adornedStart-321" style={{ position: "relative" }}>
                                        <div className="MuiInputAdornment-root-346 MuiInputAdornment-positionStart-348">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M14.6542 3.6001C11.488 3.6001 8.90683 6.18122 8.90683 9.34747C8.90683 9.73756 8.98762 10.1005 9.06225 10.4648L3.79585 15.7312C3.67148 15.8556 3.6016 16.0242 3.60156 16.2001V19.7369C3.60158 19.9128 3.67145 20.0815 3.79582 20.2058C3.92018 20.3302 4.08885 20.4001 4.26472 20.4001H7.80156C7.97744 20.4001 8.1461 20.3302 8.27047 20.2058C8.39483 20.0815 8.4647 19.9128 8.46472 19.7369V18.6317H10.0121C10.188 18.6317 10.3566 18.5618 10.481 18.4374C10.6054 18.3131 10.6752 18.1444 10.6752 17.9685V16.4211H12.2226C12.3985 16.4211 12.5672 16.3513 12.6915 16.2269C12.8159 16.1025 12.8858 15.9339 12.8858 15.758V14.7831C13.4478 14.9664 14.0333 15.0948 14.6542 15.0948C17.8204 15.0948 20.4016 12.5137 20.4016 9.34747C20.4016 6.18122 17.8204 3.6001 14.6542 3.6001ZM14.6542 4.92641C17.1036 4.92641 19.0752 6.89809 19.0752 9.34747C19.0752 11.7968 17.1036 13.7685 14.6542 13.7685C13.886 13.7685 13.1684 13.5742 12.5404 13.2314C12.4394 13.1763 12.3258 13.1484 12.2108 13.1505C12.0957 13.1526 11.9832 13.1845 11.8843 13.2432C11.7853 13.3019 11.7033 13.3854 11.6464 13.4853C11.5895 13.5853 11.5595 13.6984 11.5595 13.8134V15.0948H10.0121C9.83621 15.0949 9.66755 15.1647 9.54318 15.2891C9.41882 15.4135 9.34895 15.5821 9.34893 15.758V17.3054H7.80156C7.62569 17.3054 7.45702 17.3753 7.33266 17.4996C7.2083 17.624 7.13842 17.7926 7.1384 17.9685V19.0738H4.92788V16.4747L10.228 11.1746C10.3111 11.0915 10.3706 10.9879 10.4005 10.8742C10.4304 10.7606 10.4295 10.6411 10.3981 10.5279C10.2923 10.1473 10.2331 9.75405 10.2331 9.34747C10.2331 6.89809 12.2048 4.92641 14.6542 4.92641ZM15.5384 7.13694C15.1866 7.13694 14.8493 7.27668 14.6006 7.52541C14.3518 7.77414 14.2121 8.11149 14.2121 8.46326C14.2121 8.81502 14.3518 9.15237 14.6006 9.4011C14.8493 9.64983 15.1866 9.78957 15.5384 9.78957C15.8902 9.78957 16.2275 9.64983 16.4762 9.4011C16.725 9.15237 16.8647 8.81502 16.8647 8.46326C16.8647 8.11149 16.725 7.77414 16.4762 7.52541C16.2275 7.27668 15.8902 7.13694 15.5384 7.13694Z" fill="#3D3D8D"></path></svg>
                                        </div>

                                        <input
                                            name="password"
                                            placeholder="Nhập mật khẩu *"
                                            type={showPassword ? "text" : "password"}
                                            className="MuiInputBase-input-339 MuiOutlinedInput-input-326 MuiInputBase-inputAdornedStart-343 MuiOutlinedInput-inputAdornedStart-329"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            style={{ paddingRight: 40 }}
                                        />

                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            style={{
                                                position: "absolute",
                                                right: 12,
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                background: "none",
                                                border: "none",
                                                cursor: "pointer",
                                                padding: 4,
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            {showPassword ? (
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="#999">
                                                    <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/>
                                                </svg>
                                            ) : (
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="#999">
                                                    <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"/>
                                                </svg>
                                            )}
                                        </button>

                                        <fieldset className="jss353 MuiOutlinedInput-notchedOutline-325">
                                            <legend className="jss354">
                                                <span>&ZeroWidthSpace;</span>
                                            </legend>
                                        </fieldset>
                                    </div>
                                </div>

                                {/* AFFILIATE SALE */}
                                <div className="MuiFormControl-root-315 styles_accountCreationForm__input__1_asx styles_iconStart__c2LGF MuiFormControl-fullWidth-318">
                                    <div className="MuiInputBase-root-331 MuiOutlinedInput-root-319 sc-242007b2-0 cWOwtw MuiInputBase-formControl-332">
                                        <input
                                            name="affiliateSale"
                                            placeholder="Mã giới thiệu"
                                            type="text"
                                            className="MuiInputBase-input-339 MuiOutlinedInput-input-326"
                                            value={affiliateSale}
                                            onChange={(e) => setAffiliateSale(e.target.value)}
                                        />
                                        <fieldset className="jss353 MuiOutlinedInput-notchedOutline-325">
                                            <legend className="jss354">
                                                <span>&ZeroWidthSpace;</span>
                                            </legend>
                                        </fieldset>
                                    </div>
                                </div>

                                {/* CHECKBOX */}
                                <label
                                    className="MuiFormControlLabel-root-414 styles_checkBoxContainer__2gmeR"
                                    style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", marginTop: 4 }}
                                >
                                    <input
                                        type="checkbox"
                                        name="termsOfServiceAccepted"
                                        checked={agreed}
                                        onChange={(e) => setAgreed(e.target.checked)}
                                        style={{ width: 16, height: 16, cursor: "pointer" }}
                                    />
                                    <span className="MuiTypography-root-384 MuiTypography-body1-386">
                                        <span className="styles_agreement__VaHYQ">Tôi đồng ý với </span>
                                        <a href="/dieu-khoan-su-dung" target="_blank" rel="noopener noreferrer" style={{ color: "#1a73e8", textDecoration: "underline" }}>
                                            Điều khoản sử dụng
                                        </a>
                                    </span>
                                </label>
                            </div>

                            {/* FOOTER */}
                            <div className="styles_modalFooter__ILIux">
                                <div className="styles_accountCreationForm_groupButton__IdOoF">
                                    <button
                                        className="MuiButtonBase-root-303 styles_accountCreationForm_button__6swZv"
                                        type="submit"
                                        disabled={loading}
                                        style={loading ? { opacity: 0.7, cursor: "not-allowed" } : {}}
                                    >
                                        {loading ? "Đang xử lý..." : "Đăng ký"}
                                    </button>
                                </div>

                                <div style={{ textAlign: "center", fontSize: 14, marginTop: 8 }}>
                                    <span>Bạn đã có tài khoản? </span>
                                    <b
                                        style={{ cursor: "pointer", color: "#428c04" }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            onOpenLogin();
                                        }}
                                    >
                                        Đăng nhập ngay
                                    </b>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div >

            <div tabIndex={0} data-test="sentinelEnd" />
        </div >
    );
}
